module.exports = __webpack_public_path__ + "img/Sistema-Padaria-Balcao.d9ca2f7b.jpg";